// =====================
// Mobile Menu Handling + Mega Menu (Optimized)
// - Removes header intro delay animation
// - Keeps mega menu + mobile menu working
// - Optimizes scroll handler (passive + rAF + state)
// =====================
(() => {
  const hasGSAP = typeof window.gsap !== "undefined";
  const hasCustomEase = typeof window.CustomEase !== "undefined";

  // Register custom ease only if available
  if (hasGSAP && hasCustomEase) {
    gsap.registerPlugin(CustomEase);
    CustomEase.create("custom", "0.9,0,0.1,1");
  }

  // =====================
  // Mobile Menu
  // =====================
  const hamburger = document.getElementById("hamburger");
  const mobileNav = document.getElementById("mobileNav");
  const mobileLinks = mobileNav ? mobileNav.querySelectorAll("a") : [];
  let isOpen = false;

  function openMobileMenu() {
    if (!hamburger || !mobileNav) return;
    isOpen = true;
    hamburger.classList.add("open");
    mobileNav.classList.add("active");
    document.body.style.overflow = "hidden";

    if (!hasGSAP) return;

    gsap.fromTo(
      mobileNav,
      { y: "-100%", opacity: 0 },
      { y: 0, opacity: 1, duration: 0.25, ease: "power2.out" }
    );

    gsap.fromTo(
      mobileLinks,
      { y: 20, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.2, stagger: 0.04, ease: "power2.out", delay: 0.02 }
    );
  }

  function closeMobileMenu() {
    if (!hamburger || !mobileNav) return;
    isOpen = false;
    hamburger.classList.remove("open");
    document.body.style.overflow = "";

    if (!hasGSAP) {
      mobileNav.classList.remove("active");
      return;
    }

    gsap.to(mobileNav, {
      y: "-300%",
      opacity: 0,
      duration: 0.2,
      ease: "power2.in",
      onComplete: () => mobileNav.classList.remove("active"),
    });
  }

  if (hamburger) {
    hamburger.addEventListener("click", () => (isOpen ? closeMobileMenu() : openMobileMenu()));
  }

  mobileLinks.forEach((link) => link.addEventListener("click", closeMobileMenu));

  // =====================
  // Header Blur on Scroll (optimized)
  // =====================
  const header = document.querySelector("header");
  if (header) {
    let ticking = false;
    let isBlurred = header.classList.contains("blur");

    const update = () => {
      const shouldBlur = (window.scrollY || 0) > 0;
      if (shouldBlur !== isBlurred) {
        header.classList.toggle("blur", shouldBlur);
        isBlurred = shouldBlur;
      }
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        update();
        ticking = false;
      });
    };

    document.addEventListener("scroll", onScroll, { passive: true });
    update();
  }

  // =====================
  // Submenu Toggle
  // =====================
  document.querySelectorAll(".submenu-toggle").forEach((btn) => {
    btn.addEventListener("click", () => {
      const parent = btn.closest(".submenu-item");
      if (!parent || !parent.parentElement) return;

      const isOpenNow = parent.classList.contains("open");

      const siblings = parent.parentElement.querySelectorAll(".submenu-item.open");
      siblings.forEach((sibling) => {
        if (sibling !== parent) sibling.classList.remove("open");
      });

      parent.classList.toggle("open", !isOpenNow);
    });
  });

  // =====================
  // Mega Menu Animations (kept, fast)
  // =====================
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".group").forEach((menu) => {
      const mega = menu.querySelector(".mega-menu");
      const grid = menu.querySelector(".mega-menu-grid");
      if (!mega) return;

      // No GSAP fallback: instant show/hide
      if (!hasGSAP) {
        mega.style.opacity = "0";
        mega.style.pointerEvents = "none";
        mega.style.transform = "translateY(-6px)";

        const show = () => {
          mega.style.opacity = "1";
          mega.style.pointerEvents = "auto";
          mega.style.transform = "translateY(0)";
          mega.setAttribute("aria-hidden", "false");
        };
        const hide = () => {
          mega.style.opacity = "0";
          mega.style.pointerEvents = "none";
          mega.style.transform = "translateY(-6px)";
          mega.setAttribute("aria-hidden", "true");
        };

        menu.addEventListener("mouseenter", show);
        menu.addEventListener("mouseleave", hide);
        menu.addEventListener("focusin", show);
        menu.addEventListener("focusout", (e) => {
          if (!menu.contains(e.relatedTarget)) hide();
        });
        return;
      }

      const items = grid ? grid.querySelectorAll("ul li a") : [];

      gsap.set(mega, { y: -12, opacity: 0, pointerEvents: "none" });
      if (grid) gsap.set(grid, { y: -8, opacity: 0 });
      if (items.length) gsap.set(items, { y: -8, opacity: 0 });

      const easeName = hasCustomEase ? "custom" : "power2.out";
      const tl = gsap.timeline({ paused: true });

      tl.to(mega, {
        y: 0,
        opacity: 1,
        duration: 0.25,
        ease: easeName,
        onStart: () => (mega.style.pointerEvents = "auto"),
      });

      tl.to("section", { opacity: 0.75, duration: 0.25, ease: "power2.out" }, "<");

      if (grid) tl.to(grid, { y: 0, opacity: 1, duration: 0.22, ease: "power2.out" }, 0.02);

      if (items.length) {
        tl.to(items, { y: 0, opacity: 1, duration: 0.2, stagger: 0.03, ease: "power2.out" }, 0.04);
      }

      tl.eventCallback("onReverseComplete", () => {
        mega.style.pointerEvents = "none";
      });

      menu.addEventListener("mouseenter", () => {
        tl.play();
        mega.setAttribute("aria-hidden", "false");
      });

      menu.addEventListener("mouseleave", () => {
        tl.reverse();
        mega.setAttribute("aria-hidden", "true");
      });

      menu.addEventListener("focusin", () => {
        tl.play();
        mega.setAttribute("aria-hidden", "false");
      });

      menu.addEventListener("focusout", (e) => {
        if (!menu.contains(e.relatedTarget)) {
          tl.reverse();
          mega.setAttribute("aria-hidden", "true");
        }
      });
    });
  });
})();